<template>
  <div>
    <div class="header-with-dd d-flex">
      <h3 class="header-row semi-bold">Create Fabric</h3>
      <div
        class="select-fabric row d-flex"
        v-if="this.$auth.user().role === 'admin'"
      >
        <v-select
          :options="fabricsList"
          label="name"
          :reduce="(entry) => entry.id"
          @input="getFabricConfig"
          placeholder="Choose One"
        />
        <button class="btn btn-sm btn-primary" @click="copyFabricConfig">
          Copy Fabric
        </button>
      </div>
    </div>

    <div class="alert alert-danger mt-20" v-if="Object.keys(errors).length">
      <h4 class="semi-bold text-danger">
        <span class="fa fa-exclamation-triangle"></span> Sorry, there were some
        errors!
      </h4>
      <p class="text-danger">
        Please check the form, correct the issues and try again.
      </p>
    </div>

    <!-- General Fabric Detail -->
    <div class="grid shadow bg-white">
      <div class="grid-title d-flex">
        <h4>General Fabric Detail</h4>
      </div>
      <div class="grid-body">
        <div class="row">
          <!-- Fabric Form Fields Wrapper -->
          <FabricGeneralDetails
            :fieldValues="fieldValues"
            :modelValues="fabric"
            :errors="errors"
          >
          </FabricGeneralDetails>
          <!-- Fabric Form Fields Wrapper -->
        </div>
      </div>
    </div>
    <!-- General Fabric Detail -->

    <div class="row d-flex">
      <!-- Additional Fabric Details -->
      <div class="col-md-6 d-flex">
        <div class="grid shadow bg-white">
          <div class="grid-title">
            <h4>Additional Fabric Detail</h4>
          </div>
          <div class="grid-body">
            <FabricAdditionalDetail
              :fieldValues="fieldValues"
              :modelValues="fabric"
              :errors="errors"
            >
            </FabricAdditionalDetail>
          </div>
        </div>
      </div>
      <!-- Additional Fabric Details -->

      <!-- Fabric Dimension and Price Details -->
      <div class="col-md-6 d-flex">
        <div class="grid shadow bg-white">
          <div class="grid-title">
            <h4>Fabric Dimensions and price details</h4>
          </div>
          <div class="grid-body">
            <FabricDimensionPriceDetails
              :fieldValues="fieldValues"
              :modelValues="fabric"
              :errors="errors"
            >
            </FabricDimensionPriceDetails>
          </div>
        </div>
      </div>
      <!-- Fabric Dimension and Price Details -->
    </div>

    <!-- Save Fabric Button -->
    <button class="btn-primary btn-large btn btn-block" @click="saveData()">
      Create Fabric
    </button>
    <!-- Save Fabric Button -->
  </div>
</template>
<script>
import FabricUploadImage from "./components/FabricUploadImage";
import FabricGeneralDetails from "./components/FabricGeneralDetails";
import FabricAdditionalDetail from "./components/FabricAdditionalDetail";
import FabricDimensionPriceDetails from "./components/FabricDimensionPriceDetails";
import app from "../Tools/Fabric";

export default {
  components: {
    FabricUploadImage,
    FabricGeneralDetails,
    FabricAdditionalDetail,
    FabricDimensionPriceDetails,
  },
  data() {
    return {
      fabricToCopy: {},
      fabricsList: [],
      errors: {},
      fieldValues: {
        weaves: [],
        fibers: [],
        finishes: [],
        patterns: [],
        coloringStyles: [],
        fabricTypes: [],
        suppliers: [],
        buttonColors: [],
        threadColors: [],
        embroideryThreadColors: [],
        fabricFamilies: [],
        usageTypes: [],
        compositionLabels: [],
        formattedCompositionLabels: [],
        interlinings: [],
        interliningColors: []
      },
      fabric: {
        image_url: null,
        id: null,
        name: null,
        pattern: null,
        comfort: 1,
        default_currency: "THB",
        wrinkles: null,
        ironing: 1,
        fiber_1: null,
        fiber_1_percentage: null,
        fiber_2: null,
        fiber_2_percentage: null,
        fiber_3: null,
        fiber_3_percentage: null,
        fabric_composition_label_id: null,
        default_weave: null,
        default_width: null,
        default_height: null,
        default_unit: "m",
        default_unit_price: null,
        default_vat_per_unit: null,
        default_unit_price_total: null,
        default_yarn_count: null,
        default_density: null,
        default_weight: null,
        default_coloring_style: null,
        color_family: null,
        usage_type: "casual",
        knit_type: null,
        default_finish: null,
        current_fabric_supplier_id: null,
        current_fabric_supplier_code: null,
        button_color_id: null,
        thread_color_id: null,
        embroidery_thread_color_id: null,
        fabric_family_id: null,
        is_shirt_fabric: 1,
        is_stretch_fabric: 0,
        is_jersey_fabric: 0,
        gender_suitable_for: "male",
        type: "Main",
        sample_book: 1,
        status: "not_released_yet",
        add_ons: [],
        future: "keep",
        note: "",
        matching: 1,
        design_extra: 0,
        interlining_color: "white",
        interlining: "hard",
        special_description_suffix: null,
        description: null,
        description_en: null,
        repetition_wrap: 0,
        repetition_weft: 0,
        usable_width: 0,
        families: [],
      },
    };
  },

  mounted() {
    this.getPageData();
  },
  methods: {
    async getFabricConfig(id) {
      try {
        let results = await axios({
          method: "get",
          url: "/v2/fabrics/" + id,
        });
        this.fabricToCopy = results.data.data;
      } catch (error) {
        toastr.error(
          "There was an error getting the fabric with the ID specified"
        );
      }
    },

    copyFabricConfig() {
      if (!this.fabricToCopy) {
        toastr.error("Please pick a fabric from the dropdown to copy.");
        return;
      }

      const selectedFields = [
        "pattern",
        "comfort",
        "ironing",
        "fabric_composition_label_id",
        "default_weave",
        "default_width",
        "default_unit",
        "default_unit_price",
        "default_vat_per_unit",
        "default_unit_price_total",
        "default_currency",
        "default_yarn_count",
        "default_density",
        "default_weight",
        "default_coloring_style",
        "usage_type",
        "default_finish",
        "current_fabric_supplier_id",
        "current_fabric_supplier_code",
        "button_color_id",
        "thread_color_id",
        "embroidery_thread_color_id",
        "white_fabric_id",
        "matching",
        "interlining_color",
        "interlining",
        "design_extra",
        "is_shirt_fabric",
        "is_stretch_fabric",
        "is_jersey_fabric",
        "gender",
        "type",
        "certificate",
        "repetition_wrap",
        "repetition_weft",
        "usable_width",
      ];

      this.fabric = {
        ...this.fabric,
        ...selectedFields.reduce(
          (fields, field) => ({ ...fields, [field]: this.fabricToCopy[field] }),
          {}
        ),
      };
    },

    /**
     * When a sub-component emits an 'component-updated'
     * event, it is handled by this method which just
     * merges the this.fabric object with the event data.
     */
    handleSubComponentUpdated(event) {
      this.fabric = { ...this.fabric, ...event };
    },

    async getPageData() {
      try {
        let results = await axios({
          method: "get",
          url: "/v2/fabrics/create",
        });
        this.fieldValues = results.data.data;
        this.fabricsList = Object.entries(
          results.data.data.fabrics_list
        ).map(([key, value]) => ({ name: key, id: value }));

        // Set default 'other' as fabric family to be pre selected
        const defaultFabricFamily = results.data.data.fabricFamilies.find((family) => family.id === 22);
        this.fabric.families = [defaultFabricFamily];

        this.fieldValues.formattedCompositionLabels = app.getFormattedCompositionLabels(
          this.fieldValues.compositionLabels
        );
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("Something Went Wrong! Please Try Again");
        }
      }
    },

    async saveData() {
      this.errors = {};
      try {
        let response = await axios.post("/v2/fabrics", this.fabric);
        if (response.data.status === "OK") {
          this.$router.push("/fabric/listing/list_view");
        }
      } catch (error) {
        window.scrollTo(0, 0);
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
        }
      }
    },
  },
};
</script>

<style scoped>
@import "~vue-slider-component/theme/default.css";
@import "~vue-select/dist/vue-select.css";

.header-row {
  margin-bottom: 2px;
}

.col-form-label {
  margin-top: 10px;
}

.form-control {
  border-radius: 5px !important;
}

.slider-container {
  margin-top: 10px;
}

.d-flex {
  display: flex !important;
}

.d-flex .grid {
  width: 100%;
}
.header-with-dd {
  justify-content: space-between;
  margin-bottom: 18px;
}
.select-fabric {
  padding-bottom: 10px;
  margin-right: 10px;
}

.select-fabric .v-select {
  margin-right: 10px;
  min-width: 150px;
}

.vs--searchable .vs__dropdown-toggle {
  min-width: 150px !important;
}
</style>
